import React, { useEffect, useState } from "react";
import { Form, Input, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineReload } from "react-icons/ai";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import axios from "axios";
import swal from "sweetalert";
import { fetchSponsorDropdown } from "../../../redux/getDropDownReducer/getSponsor";

const { Option } = Select;

const CATEGORY_OPTIONS = [
  { value: "pick", label: "Pick" },
  { value: "cast", label: "Cast" },
];

const CompetitionV2Create = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [sponsorSearch, setSponsorSearch] = useState("");
  const { data: sponsordropdown } = useSelector((state) => state.sponsordropdown);

  useEffect(() => {
    dispatch(fetchSponsorDropdown({ value: "" }));
  }, [dispatch]);

  const loadSponsors = () => dispatch(fetchSponsorDropdown({ value: sponsorSearch }));

  const onCreate = async (values) => {
    setLoading(true);
    try {
      const body = {
        NameEn: values.NameEn,
        NameAr: values.NameAr,
        CompetitionCode: values.CompetitionCode,
        CompetitionCategory: values.CompetitionCategory,
        CompetitionSponsor: values.CompetitionSponsor,
        AllowedHorseSelections:
          values.CompetitionCategory === "pick"
            ? 1
            : Number(values.AllowedHorseSelections || 1),
        StartDateTimeUtc: new Date(values.StartDateTimeUtc).toISOString(),
        EndDateTimeUtc: new Date(values.EndDateTimeUtc).toISOString(),
      };
      const { data } = await axios.post(`${window.env.API_URL}/competition-v2`, body);
      swal("Success!", "Competition created successfully", "success");
      form.resetFields();
    } catch (error) {
      const message = error?.response?.data?.message || error.message || "Request failed";
      swal("Error!", message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="rightsidedata">
        <div style={{ marginTop: "30px" }}>
          <div className="Header ">
            <h4>Competition Create</h4>
            <OverlayTrigger overlay={<Tooltip id="tooltip-refresh-v2-create">Fetch New</Tooltip>}>
              <span className="addmore" onClick={loadSponsors}>
                <AiOutlineReload />
              </span>
            </OverlayTrigger>
          </div>

          <div className="form">
            <Form form={form} onFinish={onCreate} name="competition_v2_create">
              <div className="row mainrow">
                <div className="col-sm">
                  <Form.Item
                    name="NameEn"
                    label="Name"
                    rules={[{ required: true, message: "Name (English) is required" }]}
                  >
                    <Input placeholder="Competition name" />
                  </Form.Item>
                </div>
                <div className="col-sm">
                  <Form.Item
                    name="NameAr"
                    label="اسم"
                    style={{ direction: "rtl" }}
                    rules={[{ required: true, message: "Name (Arabic) is required" }]}
                  >
                    <Input placeholder="اسم" />
                  </Form.Item>
                </div>
              </div>

              <div className="row mainrow">
                <div className="col-sm">
                  <Form.Item
                    name="CompetitionCode"
                    label="Code"
                    rules={[{ required: true, message: "Competition code is required" }]}
                  >
                    <Input placeholder="Competition code" />
                  </Form.Item>
                </div>
                <div className="col-sm">
                  <Form.Item
                    name="CompetitionCategory"
                    label="Category"
                    initialValue="pick"
                    rules={[{ required: true, message: "Category is required" }]}
                  >
                    <Select placeholder="Select category">
                      {CATEGORY_OPTIONS.map((item) => (
                        <Option key={item.value} value={item.value}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>

              <div className="row mainrow">
                <div className="col-sm">
                  <Form.Item
                    name="CompetitionSponsor"
                    label="Sponsor"
                    rules={[{ required: true, message: "Sponsor is required" }]}
                  >
                    <Select
                      showSearch
                      filterOption={false}
                      onSearch={setSponsorSearch}
                      onFocus={loadSponsors}
                      placeholder="Please select a Sponsor"
                    >
                      {(sponsordropdown || []).map((item) => (
                        <Option key={item._id} value={item._id}>
                          {item.TitleEn}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                <div className="col-sm">
                  <Form.Item
                    name="AllowedHorseSelections"
                    label="Allowed Horse Selections"
                    initialValue={1}
                    rules={[{ required: true, message: "Allowed selections is required" }]}
                  >
                    <Input type="number" min="1" />
                  </Form.Item>
                </div>
              </div>

              <div className="row mainrow">
                <div className="col-sm">
                  <Form.Item
                    name="StartDateTimeUtc"
                    label="Start UTC Datetime"
                    rules={[{ required: true, message: "Start datetime is required" }]}
                  >
                    <Input type="datetime-local" />
                  </Form.Item>
                </div>
                <div className="col-sm">
                  <Form.Item
                    name="EndDateTimeUtc"
                    label="End UTC Datetime"
                    rules={[{ required: true, message: "End datetime is required" }]}
                  >
                    <Input type="datetime-local" />
                  </Form.Item>
                </div>
              </div>

              <div className="ButtonSection" style={{ justifyContent: "end" }}>
                <button className="SubmitButton" type="submit" disabled={loading}>
                  Create Competition
                </button>
              </div>
            </Form>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CompetitionV2Create;
